import { useEngineStore } from '../stores/use-engine-store'
import { MAX_SHARE_MESSAGES, type SharePayload } from '../types/share'

export function useShareActions() {
  // Store setters
  const setShareMode = useEngineStore((s) => s.shareMode.setShareMode)
  const toggleMessageSelection = useEngineStore(
    (s) => s.shareMode.toggleMessageSelection
  )
  const clearSelection = useEngineStore((s) => s.shareMode.clearSelection)
  const selectedIds = useEngineStore((s) => s.shareMode.selectedMessageIds)
  const messages = useEngineStore((s) => s.messages.messages)
  const currentEngine = useEngineStore((s) => s.engine.currentEngine)
  return {
    // 进入分享模式（可选：预选当前消息）
    enterShareMode: (initialMessageId?: string) => {
      clearSelection()
      if (initialMessageId) {
        toggleMessageSelection(initialMessageId)
      }
      setShareMode(true)
    },
    // 退出分享模式
    exitShareMode: () => {
      setShareMode(false)
    },
    // 切换消息选中状态
    toggleMessage: (id: string) => {
      toggleMessageSelection(id)
    },
    // 构建分享数据
    buildSharePayload: (): SharePayload | null => {
      if (!currentEngine || selectedIds.size === 0) return null

      const selectedMessages = (messages || [])
        .filter((m) => selectedIds.has(m.id))
        .map((m) => ({ id: m.id, role: m.role, content: m.content }))

      return {
        engineId: currentEngine.id,
        engineTitle: currentEngine.title,
        engineCoverUrl: currentEngine.coverURL,
        shareUrl: `${window.location.origin}/chats/new/${currentEngine.id}`,
        messages: selectedMessages,
        createdAt: new Date().toISOString(),
      }
    },

    // 当前选中数量
    selectedCount: selectedIds.size,
    canShare: selectedIds.size > 0 && selectedIds.size <= MAX_SHARE_MESSAGES,
  }
}
